import {
  AccountCircle,
  FavoriteOutlined,
  Home,
  Search,
} from "@mui/icons-material";
import React from "react";
import { useNavigate } from "react-router-dom";

export const BottomNavigation = () => {
  const navigate = useNavigate();
  return (
    <div className="h-[12vh] w-[100vw] flex flex-row  pt-3 text-[0.7rem]">
      <button
        className=" flex-[1] flex flex-col justify-center items-center focus:outline-none focus:bg-transparent active:bg-transparent !important"
        onClick={() => {
          navigate("/home");
        }}
      >
        <Home
          sx={{
            fontSize: "1.7rem",
          }}
        />
        <p className="mb-10 mt-2">Home</p>
      </button>
      <button
        className="flex-[1] flex flex-col justify-center items-center "
        onClick={() => {
          navigate("/search");
        }}
      >
        <Search
          sx={{
            fontSize: "1.7rem",
          }}
        />
        <p className="mb-10 mt-2">Search</p>
      </button>
      <button
        className="flex-[1] flex flex-col justify-center items-center "
        onClick={() => {
          navigate("/activity");
        }}
      >
        <FavoriteOutlined
          sx={{
            fontSize: "1.7rem",
          }}
        />
        <p className="mb-10 mt-2">Activity</p>
      </button>
      <button
        className="flex-[1] flex flex-col justify-center items-center "
        onClick={() => {
          navigate("/profile");
        }}
      >
        <AccountCircle
          sx={{
            fontSize: "1.7rem",
          }}
        />
        <p className="mb-10 mt-2">Profile</p>
      </button>
    </div>
  );
};
